import React from 'react';
import PropTypes from 'prop-types';

function HeaderLeft({ sidebarOpen, onToggleSidebar, pageTitle, pageIcon }) {
  return (
    <div className="header-left">
      <button 
        className="sidebar-toggle d-lg-none"
        onClick={onToggleSidebar}
      >
        <i className="fas fa-bars"></i>
      </button>
      <div className="page-title">
        <i className={`fas ${pageIcon} me-2`}></i>
        <h4 className="mb-0">{pageTitle}</h4>
      </div>
    </div>
  );
}

HeaderLeft.propTypes = {
  sidebarOpen: PropTypes.bool,
  onToggleSidebar: PropTypes.func,
  pageTitle: PropTypes.string,
  pageIcon: PropTypes.string
};

export default HeaderLeft;